import { render, staticRenderFns } from "./my_projects_tab.vue?vue&type=template&id=22a4a89c"
import script from "./my_projects_tab.vue?vue&type=script&lang=js"
export * from "./my_projects_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports